import clsx from 'clsx';
import { FunctionComponent } from 'react';
import Button from '@mui/material/Button';
import './ContinueButton.scss';
import { BRAND } from '../../static/constants/brands/brand';

interface ContinueButtonProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  children?: React.ReactNode;
  disabled?: boolean | undefined;
  variant?: 'text' | 'contained' | 'outlined';
  style?: React.CSSProperties;
}
const ContinueButton: FunctionComponent<ContinueButtonProps> = ({
  children,
  onClick,
  disabled,
  variant,
  style,
}) => {
  const brand = BRAND;

  return (
    <>
      <Button
        variant={variant ? variant : 'contained'}
        className={clsx('continue-btn button', brand, { disabled })}
        onClick={onClick}
        disabled={disabled}
        style={style}
      >
        {children}
      </Button>
    </>
  );
};

export default ContinueButton;
